module.exports = __webpack_public_path__ + "static/media/OpenSans-LightItalic.86884a8b.woff2";